/**
 * Taken from https://github.com/Hotell/rex-tils
 */
type Diff<T, K> = Pick<T, Exclude<keyof T, keyof K>>;

type GetDefaultProps<P extends object, DP extends Partial<P> = Partial<P>> = DP & Diff<P, DP>;

export const createPropsGetter =
    <DP extends Readonly<object>>(_defaultProps: DP) =>
    <P extends Partial<DP>>(props: P): GetDefaultProps<P, DP> =>
        props as unknown as GetDefaultProps<P, DP>;
